import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
export const SelectChipOptionContainer = (param)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: tailwindMerge("flex w-full cursor-pointer rounded-4 bg-transparent p-1 transition-colors hover:bg-grey-4", className),
        ...restOfProps
    });
};
